import { call } from 'redux-saga/effects';
import storageUploader from '../../../../../containers/Storage/uploader/StorageUploader';

export default function* multiActFileUploadError(action) {
  const { uploadTask } = action;

  yield call(storageUploader.completeUploadProcessForFile, uploadTask.fileName);
}
